import request from "@/utils/request";
// 请求所有省份
export function viewProvince(data) {
  return request({
    url: "/apis/emc/cart/viewProvince",
    method: "post",
    data
  });
}
// 按code请求下级地址
export function qryAddress(data) {
  return request({
    url: "/apis/emc/cart/qryAddress",
    method: "post",
    data
  });
}
// 查询购物车列表
export function queryCarts(data) {
  return request({
    url: "/apis/emc/cart/queryCarts",
    method: "post",
    data
  });
}

// 分页查询购物车列表
export function queryCartsByPage(data) {
  return request({
    url: "/apis/emc/cart/queryCarts",
    method: "post",
    data
  });
}
// 查询询价购物车列表-二级集采
export function queryEmcListVs(data) {
  return request({
    url: "/apis/emc/cart/queryEmcListVs",
    method: "post",
    data
  });
}
// 查询询价购物车列表-云租
export function queryEmcListClp(data) {
  return request({
    url: "/apis/emc/cart/queryEmcListClp",
    method: "post",
    data
  });
}

// 已选择购物车商品
export function selected(data) {
  return request({
    url: "/apis/emc/cart/selected",
    method: "post",
    data
  });
}
// 删除购物车商品
export function deleteSku(data) {
  return request({
    url: "/apis/emc/cart/deleteSku",
    method: "post",
    data
  });
}
//改变购物车数量
export function modifyNumTotal(data) {
  return request({
    url: "/apis/emc/cart/modifyNumTotal",
    method: "post",
    data
  });
}
// 请求四级地址
export function qryAddressOfFourth(data) {
  return request({
    url: "/apis/emc/cart/qryAddressOfFourth",
    method: "post",
    data
  });
}
// 请求默认地址
export function qryDefault(data) {
  return request({
    url: "/apis/emc/cart/qryDefault",
    method: "post",
    data
  });
}

// 所属单位
export function qryUnitOrgTree(data) {
  return request({
    url: "/apis/emc/cart/qryUnitOrgTree",
    method: "post",
    data
  });
}
// 上传清单
export function importBatchFile(data) {
  return request({
    url: "/apis/emc/batch/importBatchFile",
    method: "post",
    data
  });
}
// 立即下单
export function batchSubPackageForPurchase(data) {
  return request({
    url: "/apis/emc/batch/batchSubPackageForPurchase",
    method: "post",
    data
  });
}
// 加入购物车
export function batchSubAddCart(data) {
  return request({
    url: "/apis/emc/batch/batchSubAddCart",
    method: "post",
    data
  });
}
// 输入sku
export function addSku(data) {
  return request({
    url: "/apis/emc/batch/addSku",
    method: "post",
    data
  });
}
// 切换地址
export function switchAddress(data) {
  return request({
    url: "/apis/emc/batch/addSkus",
    method: "post",
    data
  });
}
// 询价一键下单
export function addSkusByEmma(data) {
  return request({
    url: "/apis/emc/batch/addSkusByEmma",
    method: "post",
    data
  });
}

// 比价接口
export function querySkuAccurateComparisonMapBySkuNewId(data) {
  return request({
    url: "/apis/emc/cart/querySkuAccurateComparisonMapBySkuNewId",
    method: "post",
    data
  });
}

// 校验数量接口
export function numCheck(data) {
  return request({
    url: "/apis/emc/cart/users/signup/numCheck",
    method: "post",
    data
  });
}

// 添加商品到购物车接口
export function addNewEmc(data) {
  return request({
    url: "/apis/emc/cart/addNewEmc",
    method: "post",
    data
  });
}

// 添加商品到购物车接口
export function addCart(data) {
  return request({
    url: "/apis/emc/cart/addCart",
    method: "post",
    data
  });
}
//标签查询
export function querySkuTagConfigDetail(data) {
  return request({
    url: "/apis/emc/cart/users/signup/querySkuTagConfigDetail",
    method: "POST",
    data
  });
}

//取消关注
export function deleteFocusSkuInfo(data) {
  return request({
    url: "/apis/emc/cart/deleteFocusSkuInfo",
    method: "POST",
    data
  });
}

//关注
export function addFocusSkuInfo(data) {
  return request({
    url: "/apis/emc/cart/addFocusSkuInfo",
    method: "POST",
    data
  });
}
//从购物车移到我的关注
export function moveToMyFocusFromCart(data) {
  return request({
    url: "/apis/emc/cart/moveToMyFocusFromCart",
    method: "POST",
    data
  });
}

//关注列表
export function getFocusSkuPageList(data) {
  return request({
    url: "/apis/emc/cart/getFocusSkuPageList",
    method: "POST",
    data
  });
}

//查询购物车中无货、下架、30天前加购商品
export function getMyCartFocusSkuList(data) {
  return request({
    url: "/apis/emc/cart/getMyCartFocusSkuList",
    method: "POST",
    data
  });
}

//校验商品是否下架，售罄，价格变化.只校验云商商品
export function checkShopStatus(data) {
  return request({
    url: "/apis/emc/cart/checkShopStatus",
    method: "POST",
    data
  });
}
//采购单位是否有询价权限
export function qrySeekPermission(data) {
  return request({
    url: "/apis/emc/spc/qrySeekPermission",
    method: "POST",
    data
  });
}

//校验商品是否冻结
export function checkFrozenSkuInfos(data) {
  return request({
    url: "/apis/emc/cart/checkFrozenSkuInfos",
    method: "POST",
    data
  });
}

// 关注店铺
export function addShopFocus(data) {
  return request({
    url: "/apis/emc/spc/addShopFocus",
    method: "POST",
    data
  });
}

// 取消关注店铺
export function deleteShopFocus(data) {
  return request({
    url: "/apis/emc/spc/deleteShopFocus",
    method: "POST",
    data
  });
}

// 批量取消关注店铺
export function batchDeleteShopFocus(data) {
  return request({
    url: "/apis/emc/spc/batchDeleteShopFocus",
    method: "POST",
    data
  });
}

// 分页查询关注店铺
export function qryShopFocusPage(data) {
  return request({
    url: "/apis/emc/spc/qryShopFocusPage",
    method: "POST",
    data
  });
}

// 检查是否已关注店铺
export function checkShopFocus(data) {
  return request({
    url: "/apis/emc/spc/checkShopFocus",
    method: "POST",
    data
  });
}
